import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  StaticPageHeader,
  NamedLink,
} from '../../components';

import pageImage from './image.jpg';
import css from './TipsPage.module.css';

const TipsPage = () => {
  return (
    <StaticPage
      title="4 Tips for Getting Your First PictureHum Booking"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'TipsPage',
        description: '4 Tips for Getting Your First PictureHum Booking',
        name: '4 Tips for Getting Your First PictureHum Booking',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <StaticPageHeader
            title={
              <span>
                4 Tips for Getting Your
                <br />
                First PictureHum Booking
              </span>
            }
            disableNav
          />
          <div className={css.staticPageWrapper}>
            <div className={css.contentWrapper}>
              <div className={css.contentMain}>
                <img src={pageImage} className={css.pageImage} />
                <ul>
                  <li>
                    <strong>Profile Photo</strong> - Be sure you have a profile photo uploaded, that
                    clearly shows your face. Clients prefer knowing who they are hiring for their
                    photo sessions.
                  </li>
                  <li>
                    <strong>Reviews</strong> - Getting that first 5-star review is crucial for
                    booking more shoots. If you have a Yelp profile with existing reviews you are
                    able to connect it to the PictureHum website. Ratings and reviews are a good way
                    for potential new clients to guarantee they will have a good experience when
                    they book you for a photo session.
                  </li>
                  <li>
                    <strong>Price Point</strong> – PictureHum allows photographers to set their own
                    rates for photo sessions. Photographers are always able to adjust this rate as
                    they book more sessions. We highly recommend starting at a rate that may be a
                    bit lower than you normally charge in order to attract an initial booking of
                    your profile on the site. Once you get some rave reviews you can adjust your
                    rate accordingly.
                  </li>
                  <li>
                    <strong>Portfolio</strong> – Your portfolio is the number one way clients
                    visualize what you can do for them. Make sure to choose sample images that
                    highlight your strengths and style and of course that represent the types of
                    photo sessions you are offering. Since the first image in your profile is the
                    feature image on the listing page of PictureHum, be sure to choose one of your
                    favorites!
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default TipsPage;
